// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ThumbsDownIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ThumbsDownIcon" ref={forwardedRef} {...props}>
      <path d="M8.102 16.287 8.5 13.5H4a1 1 0 0 1-1-1v-2.267a1 1 0 0 1 .106-.448l2.618-5.232A1 1 0 0 1 6.618 4H14v9.5L10 18l-1.355-.678a1 1 0 0 1-.543-1.035M6.927 5.5 4.5 10.35V12h5.73l-.592 4.142.005.002L12.5 12.93V5.5z" />
      <path d="M17 13.5V4h-1.498v9.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ThumbsDownIcon = /* @__PURE__ */ Object.assign(
  ThumbsDownIconComponent,
  { displayName: 'ThumbsDownIcon' },
);
